import { useCallback } from 'react';

var useLinkClickHandler = function useLinkClickHandler(extraAction) {
  return useCallback(function (action) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return function (e) {
      e.preventDefault();
      action.apply(void 0, args);
      if (extraAction) {
        extraAction();
      }
    };
  }, [extraAction]);
};

export { useLinkClickHandler };
